/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypeEventEnum } from 'app/api/event/model'
import { ITradeUnionMember } from 'app/api/tradeUnionMembers/model'
import { Dayjs } from 'dayjs'

export interface IFormCreateEvent {
  name?: string
  startDate?: Dayjs | null
  endDate?: Dayjs | null
  description?: string
  startDateRegister?: Dayjs | null
  endDateRegister?: Dayjs | null
  type?: TypeEventEnum
  link?: string
}

export enum TypeColumn {
  STRING = 'string',
  DATE = 'date',
  NUMBER = 'number',
  OTHER = 'other',
}

export enum RewardTypeEnum {
  SINGLE = 'INDIVIDUAL',
  GROUP = 'COLLECTIVE',
}

export const DefineRewardType = {
  [RewardTypeEnum.SINGLE]: 'Cá nhân',
  [RewardTypeEnum.GROUP]: 'Tập thể',
}

export interface IColumnActivity {
  name?: string
  type?: TypeColumn
  keyOfMainData?: keyof ITradeUnionMember
}

export interface IDataTumActivity extends ITradeUnionMember {
  [key: string]: string | number | Date | undefined | null | boolean
}

export interface IRewardActivity {
  id?: number
  name?: string
  description?: string
  gift?: string
  type?: RewardTypeEnum
  countPerReward?: number
  key?: number
}

export interface ITeam {
  id?: number
  name?: string
  description?: string
  tums?: IDataTumActivity[]
}

export interface ILocation {
  id?: number
  address?: string
  long?: number
  lat?: number
  radius?: number
  key_map_check_in?: string
  coordinates?: string
}

export interface IActivityEvent {
  id?: any
  title?: string
  valueCare?: string
  columns?: IColumnActivity[]
  data?: IDataTumActivity[]
  rewards?: IRewardActivity[]
  teams?: ITeam[]
  locations?: ILocation[]
  limitMember?: number
  limitTeam?: number
  isHaveTeam?: boolean
  value_care?: string
}
